<template>
<v-flex>
    <v-layout row class="content-header">
        <v-flex md5 class="content-title">
            <h2>Apólices</h2>
            <h4>Consulte e faça download de apólices.</h4>
        </v-flex>
        <v-flex md3>
                <v-text-field
                v-model="search"
                label="Pesquisa"
                placeholder="Apólice, CNPJ/CPF, Estipulante/Segurado..."
                outlined
                class="input-pesquisa"
                @keyup.enter="pesquisar()"
            ></v-text-field>
        </v-flex>
        <v-flex md4>
            &nbsp;<v-btn color="info" @click="pesquisar()"><v-icon>mdi-magnify</v-icon></v-btn>
            &nbsp;&nbsp;<v-btn color="info" @click="requestApolices()">Listar Apólices Disponíveis</v-btn>
        </v-flex>
        <v-flex md12>
            <div class="line"></div>
        </v-flex>
    </v-layout>
    <v-layout row class="content-body overflow-y-auto">
        <v-flex md12>
            <v-data-table
                :headers="headers"
                :items="apolices"
                :items-per-page="topItems"
                :loading="loading"
                :search="search"
                loading-text = "Carregando... Por favor aguarde."
                :no-data-text="noDataText"
                no-results-text = "Nenhuma informação encontrada"
                :sort-by="['DataEmissao']"
                :sort-desc="[true]"                        
                class="">
                <template v-slot:item.DataEmissao="{ item }">
                    {{ FormatarData(item.DataEmissao) }}
                </template>
                <template v-slot:item.NumeroTotal="{ item }">
                    {{ item.NumeroSub == '-' ? '-' : item.NumeroTotal }}
                </template>
                <template v-slot:item.CnpjCpf="{ item }">
                    {{ formatarCpfCnpj(item.CnpjCpf) }}
                </template>
                <template v-slot:item.anexo="{ item }" style="display:none;">
                    <img class="hover" src="/img/icon-pdf.png" @click="gerarApolice(item)" />
                </template>
            </v-data-table>
        </v-flex>

        <v-overlay :value="fullLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-layout>
</v-flex>
</template>

<script>

import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';
import Helpers from "@/utilities/Helpers";

    export default {
        mixins: [Helpers],
        data() {
            return {
                search: "",
                baseURL: Vue.prototype.$httpPortal.defaults.baseURL,
                termoPesquisa: "",
                loading: false,
                fullLoading: false,
                topItems: 10,
                options: {},
                headers: [
                    {text: "Apólice", value: "NumeroApolice", sortable: true},
                    {text: "Apólice", value: "NumeroApoliceSemPonto", sortable: false, align: ' d-none'},
                    {text: "Sub", value: "NumeroSub", sortable: true},
                    {text: "Total Módulos", value: "NumeroTotal", sortable: true},
                    {text: "Estipulante/Segurado", value: "EstipulanteSegurado", sortable: true},
                    {text: "CNPJ/CPF", value: "CnpjCpf", sortable: true},
                    {text: "CNPJ/CPF com ponto", value: "CnpjCpfComPonto", sortable: false, align: ' d-none'},
                    {text: "Emissão", value: 'DataEmissao', sortable: true},
                    {text: "Download", value: "anexo", sortable: false }
                ],
                apolices: [],
                noDataText : "Nenhuma informação pesquisada",
            }
        },
        methods: {
            requestApolices(){
                this.loading = true;
                this.fullLoading = true;
                let codigoCorretor = this.usuario.codCorretor;

                //let url = "ResumoFatura/Apolices/" + codigoCorretor;
                let url = "Apolice/Resumo/" + codigoCorretor;

                if(this.search != "")
                    url += "/"+this.search.replace("/","_");

                // Request apolices
                Vue.prototype.$httpPortal.get(url)
                .then(res => {
                    console.log(res.data);
                    this.apolices = res.data;

                    if(res.data.length == 0)
                    {
                        this.noDataText = "Nenhuma informação encontrada";
                    } 
                    for(let index in this.apolices)
                    {
                        this.apolices[index].NumeroApoliceSemPonto = this.apolices[index].NumeroApolice.split('.').join('').split('-').join('');
                        this.apolices[index].CnpjCpfComPonto = this.formatarCpfCnpj(this.apolices[index].CnpjCpf) 
                    }
                    //this.search = "";
                    this.loading = false;
                    this.fullLoading = false;
                })
                .catch(ex => {
                    console.log(ex);
                    this.noDataText = "Nenhuma informação encontrada";
                    this.loading = false;
                    this.fullLoading = false;
                });        
            },
            pesquisar(){
                this.requestApolices()
            },
            gerarApolice(value){
                let codigoCorretor = this.usuario.codCorretor;
                let url = this.baseURL + "Emissao/Apolice/Resumo/" + value.NumeroApolice + "/" + value.UltimaFatura + "/" + value.UltimoCertificado;
                //let url = this.baseURL + "Emissao/Apolice/" + value.NumeroApolice;

                // se for I4PRO pega o link
                if(value.Sistema == "SNGS"){
                    //console.log("url aqui : " + url);
                    window.open(url, "_blank");                   
                }
                else{
                    if (value.EnderecoArquivo != null)
                    {
                        window.open(value.EnderecoArquivo, "_blank");    
                    }
                    else
                    {
                        this.showToast("error", "Atenção!", "Arquivo não disponível para download.");
                    }
                    // this.fullLoading = true;
                    // let url = this.baseURL + "EmissaoApolice/ApoliceI4Pro/" + value.apolice;
                    // Vue.prototype.$httpPortal.get(url)
                    // .then(res => {
                    //     console.log(res.data);
                    //     this.loading = false
                    //     this.fullLoading = false;
                    //     window.open(res.data.linkApolice, "_blank");                   
                    // })
                    // .catch(ex => {
                    //     console.log(ex);
                    //     this.loading = false;
                    //     this.fullLoading = false;
                    // });        
                }
            },
        },
        watch: {

        }, 
        computed: {
        ...mapGetters("usuarioModule", { usuario: "getUserInfo" })
        },
        mounted(){            
            //this.requestApolices()
        },
    }
</script>
